import ManagementApiResources from '../../constants/api/resources/management';
import ApiService from '@/services/_helper/api.service';
import FileService from '@/services/_helper/file.service';
import moment from 'moment';

const GoToCampaignService = {
  getGoToCampaign() {
    return ApiService.get(ManagementApiResources.goToCampaign);
  },
  getGoToCampaignBookingsPdf() {
    return ApiService.get(ManagementApiResources.getGoToCampaignBookingsPdf).then(res => {
      FileService.saveFileByUrl('data:application/pdf;base64,' + res.data.base64, res.data.filename);
      return res;
    });
  },

  triggerGoToCampaignActivation(data: any) {
    return ApiService.put(ManagementApiResources.goToCampaignActivation, data);
  },
  updateBudgetSettings(data: any) {
    return ApiService.put(ManagementApiResources.goToCampaign, data);
  },
};

export default GoToCampaignService;
